// extracted by mini-css-extract-plugin
export default {"wrapper":"CalculationAuthor_wrapper__hhIHr","inputSpace":"CalculationAuthor_inputSpace__xXf99","buttonToRight":"CalculationAuthor_buttonToRight__BFcOG"};